import {useRegionLinkSubber} from "../../hooks/region";
import {isUrlAbsolute} from "../../utils/url";
import Link from "next/link";
import React from "react";
import {ImagePageHotspot} from "../../types/models/image_page";

interface HotspotOverlayProps {
  hotspots: ImagePageHotspot[];
}

export default function HotspotsOverlay({hotspots}: HotspotOverlayProps) {
  const regionLinkSubber = useRegionLinkSubber()

  const style: React.CSSProperties = {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  }

  return (
    <div>
      {hotspots.map((hotspot, index) => {
        const itemStyle: React.CSSProperties = {
          width: `${hotspot.width}%`,
          height: `${hotspot.height}%`,
          top: `${hotspot.y}%`,
          left: `${hotspot.x}%`,
          ...style
        }
        const href = regionLinkSubber(hotspot.link)

        if (isUrlAbsolute(href)) {
          return <a
            key={index}
            style={itemStyle}
            href={regionLinkSubber(hotspot.link)}
          />
        } else {
          return (
            <Link href={regionLinkSubber(hotspot.link)} key={index} style={itemStyle}>

            </Link>
          );
        }
      })}
    </div>
  );
}